<template>
  <div class="flow-confirm-details">
    <div class="flow-confirm-details__header">{{ header }} | {{ currentDate }}</div>
    <div v-for="detail in details" :key="detail.name">
      <h4 class="flow-confirm-details__name">{{ detail.name }}</h4>
      <p class="flow-confirm-details__content" v-if="!detail.groups">{{ detail.content }}</p>
      <template v-else>
        <span v-for="group in detail.groups" :key="group.id" class="flow-badge" v-tooltip="group.name">{{
          group.name
        }}</span>
      </template>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import dateFormatter from '../../mixins/dateFormatter';
export default {
  name: 'flow-confirm-details',
  mixins: [dateFormatter],
  props: {
    header: {
      type: String,
      required: true,
    },
    details: {
      type: Array,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
  },
  computed: {
    currentDate() {
      const date = this.dateLarge(new Date(), this.timezone);
      return date.substring(0, date.indexOf(',') + 6);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.flow-confirm-details {
  background: $white-color;
  padding: 16px 16px 8px;
  border: 1px solid $platinum-color;
  border-radius: 4px;
  text-align: left;
  margin-bottom: 30px;
  &__header {
    color: $dove-grey-color;
    margin-bottom: 16px;
  }
  &__name {
    font-weight: 600;
    font-size: 20px;
    margin: 16px 0 8px;
  }
  &__content {
    margin-bottom: 8px;
    line-height: 16px;
  }
}

.flow-badge {
  border-radius: 100px;
  padding: 6.5px 12px;
  font-size: 12px;
  display: inline-block;
  margin: 0 8px 8px 0;
  background: #b2dedf;
  color: $mine-shaft-color;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
